var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCard1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 62,
    height: 62,
    viewBox: "0 0 62 62",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.0293 49.8417C15.2228 49.8417 14.4541 49.4641 13.7232 48.7089C12.9923 47.9538 12.6269 47.1734 12.6269 46.3679V38.6652H50.8098V12.6118H58.6732C59.4797 12.6118 60.2358 12.9894 60.9415 13.7446C61.6472 14.4997 62 15.3053 62 16.1611V61.9999L49.9025 49.8417H16.0293Z",
    fill: "#256BE4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 46.4429V3.47378C0 2.66827 0.352845 1.88792 1.05854 1.13275C1.76423 0.377585 2.52032 0 3.32683 0H42.8707C43.7276 0 44.5089 0.364999 45.2146 1.095C45.9203 1.82499 46.2731 2.61792 46.2731 3.47378V30.6599C46.2731 31.4654 45.9203 32.2458 45.2146 33.0009C44.5089 33.7561 43.7276 34.1337 42.8707 34.1337H12.3244L0 46.4429Z",
    fill: "#0B0F5E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCard1);
export default __webpack_public_path__ + "static/media/card1.b39b39fb7209baf21b510b9ceb52fe37.svg";
export { ForwardRef as ReactComponent };